import * as logger from '../logger';

export enum Message {
  ActiveAction = 'ACTIVE_ACTION',
  FormCompleted = 'FORM_COMPLETED',
  InitialPageLoadCompleted = 'INITIAL_PAGE_LOAD_COMPLETED',
  InitialPageLoadStarted = 'INITIAL_PAGE_LOAD_STARTED',
  Logout = 'LOGOUT',
}

function callbackNativeWebkit(message: Message) {
  // Notable iPad app
  try {
    if ((window as any).webkit?.messageHandlers?.callbackHandler) {
      (window as any).webkit.messageHandlers.callbackHandler.postMessage(
        message,
      );
    }
  } catch (err) {
    logger.error(err, `failed to callback ${message} to native app`);
  }
}

function callbackIonic(message: Message) {
  // Marshfield iOS/Android apps
  window.postMessage(message, '*');
}

export function sendEventMessage(message: Message) {
  callbackNativeWebkit(message);
  callbackIonic(message);
}
